export default __webpack_public_path__ + "static/media/dd5d59c3308fe15b61e6b20d947ef847.svg";